import type { UserOnboarding } from "@brookbush/types";

import posthog from "posthog-js";

import type { LearningPathChoice } from "~/hooks/useOnboarding";

/**
 * Sets PostHog person properties when onboarding completes, so future events and
 * cohorts can segment by onboarding outcome.
 *
 * @param {UserOnboarding} payload - The assembled onboarding payload
 * @param {LearningPathChoice | null} learningPath - The chosen learning path
 * @returns {void}
 */
export const setOnboardingPersonProperties = (
	payload: UserOnboarding,
	learningPath: LearningPathChoice | null,
): void => {
	posthog.setPersonProperties({
		onboarding_completed: true,
		learning_path: learningPath,
		primary_profession_id: payload.primaryProfessionId ?? null,
		selected_certification_id: payload.selectedCertificationId ?? null,
		ceu_accreditation_count: payload.ceuGoals?.length ?? 0,
	});
};
